import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@design-system';
import { Link, UserPlus } from 'lucide-react';

interface PartnerRequiredDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTakeMeToIt: () => void;
  onLinkExisting?: () => void;
}

export function PartnerRequiredDialog({
  open,
  onOpenChange,
  onTakeMeToIt,
  onLinkExisting,
}: PartnerRequiredDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Partner Information Required</DialogTitle>
          <DialogDescription>
            Partner information is needed to explore joint eligibility and coverage options.
          </DialogDescription>
        </DialogHeader>
        {onLinkExisting ? (
          <div className="flex flex-col gap-2">
            <Button
              variant="outline"
              className="justify-start gap-2"
              onClick={onLinkExisting}
            >
              <Link className="size-4" />
              Link Existing Client as Partner
            </Button>
            <Button
              variant="outline"
              className="justify-start gap-2"
              onClick={onTakeMeToIt}
            >
              <UserPlus className="size-4" />
              Add new partner
            </Button>
          </div>
        ) : (
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button onClick={onTakeMeToIt}>Add partner</Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
